import React, { useContext } from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

import ContentfulDataContext from "../context/contentful-data"

const Athletes = props => {
  const { allContentfulInterview } = useContext(ContentfulDataContext)

  const fontSizes = ["46%", "73%", "73%", "100%", "88%", "56%"]

  const categories = allContentfulInterview.edges.reduce(
    (acc, { node: { category } }) => {
      if (acc.indexOf(category) < 0) {
        acc.push(category)
      }

      return acc
    },
    []
  )

  if (!categories.length) {
    return ""
  }

  const interviewsByCategory = allContentfulInterview.edges.reduce(
    (acc, { node }) => {
      if (acc.hasOwnProperty(node.category)) {
        acc[node.category].push(node)
      } else {
        acc[node.category] = [node]
      }

      return acc
    },
    {}
  )

  let tagCloudComp = ""
  if (props.tagCloud) {
    tagCloudComp = (
      <aside className="tagcloud">
        {categories.map((cat, i) => {
          const fontSizeInd =
            i > fontSizes.length - 1 ? i % fontSizes.length : i

          return (
            <a
              key={cat}
              className="tag"
              href={`#${cat.toLowerCase()}`}
              style={{ fontSize: `${fontSizes[fontSizeInd]}` }}
            >
              {cat}
            </a>
          )
        })}
      </aside>
    )
  }

  const athleteComps = (
    <>
      {categories.map(cat => (
        <React.Fragment key={cat}>
          <h2 id={cat.toLowerCase()} className="athlete-category-header">
            {cat}
          </h2>
          {interviewsByCategory[cat] &&
            interviewsByCategory[cat].map(athlete => (
              <React.Fragment key={athlete.slug}>
                <h3 id={athlete.slug}>
                  <Link to={`/athletes/${athlete.slug}`}>
                    {athlete.header ? athlete.header : athlete.title}
                  </Link>
                </h3>
                <Link to={`/athletes/${athlete.slug}`}>
                  <Img
                    fluid={athlete.backgroundImage ? athlete.backgroundImage.fluid : ``}
                    alt={athlete.backgroundImage ? athlete.backgroundImage.title : ``}
                  />
                </Link>
                {athlete.excerpt ? <p>{athlete.excerpt.excerpt}</p> : ""}
              </React.Fragment>
            ))}
        </React.Fragment>
      ))}
    </>
  )

  return (
    <>
      {tagCloudComp}
      {athleteComps}
    </>
  )
}

export default Athletes
